export default {
  data() {
    return {
      weixinFlag: false,
      show: false,
      actions1: [{ name: '微信支付', type: 'wepay' }, { name: '支付宝支付', type: 'alipay' }],
      actions2: [{ name: '微信支付', type: 'wepay' }],
      payConfig: ''
    }
  },
  created() {
    this.isWeixin()
  },
  methods: {
    isWeixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // 微信
        this.weixinFlag = true
      } else {
        this.weixinFlag = false
      }
      // if (ua.search("zhqd") != -1 || ua.search("zhihuiqingdaoapp") != -1) {

      // }
    },
    Buy(id) {
      // if (this.weixinFlag) {
      this.common.request({
        url: 'Pay',
        methods: 'get',
        params: { id: id },
        callback: res => {
          if (res.data.errcode == 0) {
            if (res.data.data.is_jump) {
              window.location.href = res.data.data.url
            } else {
              this.payConfig = res.data.data.url
              this.wePay()
            }
          }
        }
      })

    },
    wePay() {
      let that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: this.payConfig.appId, //公众号名称，由商户传入
          timeStamp: this.payConfig.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: this.payConfig.nonceStr, //随机串
          package: this.payConfig.package,
          signType: this.payConfig.signType, //微信签名方式：
          paySign: this.payConfig.paySign //微信签名
        },
        function (res) {
          console.log('==>', res)
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            console.log(123)

            that.$router.push('/pay_result')
          } else {
            that.$toast.fail('支付失败')
            setTimeout(function () {
              that.$router.push('/myorder')
            }, 1000)

          }
        }
      );
    }
  }
}